import React from 'react';
import { Link } from 'react-router-dom'; // Importeer de Link component
import './Home.css';

function Home() {
    return (
        <div className="home-page">
            {/* Tekst bovenaan */}
            <h1>Coding manifests the future</h1>

            {/* Plaats de knop in een aparte div onder de tekst */}
            <div className="button-container">
                <Link to="/contact">
                    <button className="contact-btn">Contact</button>
                </Link>
            </div>
        </div>
    );
}

export default Home;
